<template>
  <div>

    <div class="row border-row">
     <div class="list form column is-24"
        style="position: relative; ">
          <div class="item">
            <div class="columns is-mobile">
              <div class="column is-6">
                <v-input class="floating-label full-width"
                placeholder="Email expéditeur défaut"
                v-model="options.from_mail">
                </v-input>
              </div>
              <div class="column is-6">
                <v-input class="floating-label full-width"
                placeholder="Nom expéditeur défaut"
                v-model="options.from_name">
                </v-input>
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column is-6">
                <v-input class="floating-label full-width"
                placeholder="Hôte"
                v-model="options.stmp_host">
                </v-input>
              </div>
              <div class="column is-2">
                <v-input class="floating-label full-width"
                placeholder="Port"
                v-model="options.stmp_port">
                </v-input>
              </div>
              <div class="column is-2">
                <v-select class="floating-label full-width"
                placeholder="Chiffrement"
                :opened.sync="secure_opened"
                v-model="options.stmp_secure"
                :items="[
                  {
                    id: 'tls',
                    n: 'TLS',
                  },{
                    id: 'ssl',
                    n: 'SSL',
                  },
                ]
                ">
                </v-select>
              </div>

            </div>

            <div class="columns is-mobile">
              <div class="column is-2">
                <v-checkbox
                style="padding-top: 1.4rem;"
                v-model="options.stmp_auth"
                label="Authentification?"></v-checkbox>
              </div>
              <div class="column is-4">
                <v-input class="floating-label full-width"
                v-if="options.stmp_auth == 1"
                placeholder="Nom d'utilisateur"
                v-model="options.stmp_username">
                </v-input>
              </div>
              <div class="column is-4">
                <v-input class="floating-label full-width"
                v-if="options.stmp_auth == 1"
                placeholder="Mot de passe"
                type="password"
                v-model="options.stmp_password">
                </v-input>
              </div>

            </div>

            <div class="columns is-mobile">
              <div class="column is-4">
                <v-input class="floating-label full-width"
                placeholder=" Nombre d'envois par passe "
                v-model="options.send_number">
                </v-input>
              </div>

            </div>
            <div class="columns is-mobile">
              <div
              class="button primary full-width"
              style="border: 0;"
              @click="save">Sauvegarder</div>

            </div>
          </div>
        </div>
      </div>

  </div>
</template>
<script>
  
export default {
  title: 'MailingSending',
  data: function () {
    return {
      secure_opened: false,
      options: {
        stmp_host: '',
        stmp_port: 587,
        stmp_secure: 'tls',
        stmp_username: '',
        stmp_password: '',
        stmp_auth: 0,
        send_number: 50,
        from_mail: 'contact@fnepaca.fr',
        from_name: "FNE Provence-Alpes-Côte d'Azur"
      },
    }
  },
  computed: {

  },
  mounted: function () {
    var vm = this

    vm.get_options()
  },
  methods: {
    save: function () {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=set_options', {
          token: global.token,
          options: vm.options
        }
      )
      .then((response) => {
        // if(response &&
        // response.body &&
        // response.body.options) {
        //   vm.options = response.body.options
        //   for(name in response.body.options){
        //     vm.options[name] = response.body.options[name]
        //   }
        // }
      }, (response) => {

      })
    },
    get_options: function () {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=get_options', {
          token: global.token
        }
      )
      .then((response) => {
        if(response &&
        response.body &&
        response.body.options) {
          vm.options = response.body.options
          for(name in response.body.options){
            vm.options[name] = response.body.options[name]
          }
        }
      }, (response) => {

      })
    },

  }
}
</script>
<style>

</style>
